import produce from 'immer';
import { PagingActions, PagingOptions } from '../../models/types';
import { loadPagingOptions } from '../../utils/sort-table.utils';
import {
	THEME_LOAD,
	THEME_LOAD_DEFAULT,
	THEME_LOAD_REGION_LIST,
	THEME_LOAD_LIST_OPTIONS,
	THEME_LOAD_CHAPTER_LIST,
	THEME_LOAD_LIST
} from './theme.actions';
import { IThemeState, Theme, ThemeActions } from './theme.types';

const themeInitialState: IThemeState = {
	regionThemes: [],
	chapterThemes: [],
	themes: [],
	theme: getEmptyTheme(),
	pagingOptions: {
		currentPage: 0,
		pageSize: 10,
		totalPages: 0
	}
};

export function themeReducer(
	state: IThemeState = themeInitialState,
	action: ThemeActions | PagingActions
): IThemeState {
	switch (action.type) {
		case THEME_LOAD_DEFAULT: {
			return loadTheme(state, getEmptyTheme());
		}
		case THEME_LOAD_REGION_LIST: {
			return loadRegionThemeList(state, action.payload as Theme[]);
		}
		case THEME_LOAD_CHAPTER_LIST: {
			return loadChapterThemeList(state, action.payload as Theme[]);
		}
		case THEME_LOAD_LIST: {
			return loadThemeList(state, action.payload as Theme[]);
		}
		case THEME_LOAD: {
			return loadTheme(state, action.payload as Theme);
		}
		case THEME_LOAD_LIST_OPTIONS: {
			return loadPagingOptions(state, action.payload as PagingOptions);
		}
		default: {
			return state;
		}
	}
}

function loadRegionThemeList(
	currentState: IThemeState,
	themes: Theme[]
): IThemeState {
	return produce(currentState, (draftState: IThemeState) => {
		draftState.regionThemes = themes;
		draftState.themes = themes;
	});
}

function loadChapterThemeList(
	currentState: IThemeState,
	themes: Theme[]
): IThemeState {
	return produce(currentState, (draftState: IThemeState) => {
		draftState.chapterThemes = themes;
		draftState.themes = themes;
	});
}

function loadThemeList(
	currentState: IThemeState,
	themes: Theme[]
): IThemeState {
	return produce(currentState, (draftState: IThemeState) => {
		draftState.themes = themes;
	});
}

function loadTheme(currentState: IThemeState, theme: Theme): IThemeState {
	return produce(currentState, (draftState: IThemeState) => {
		draftState.theme = theme;
	});
}

function getEmptyTheme(): Theme {
	return {
		id: undefined,
		name: '',
		parent: '',
		regionId: ' ',
		chapterId: ' ',
		licenceIds: [],
		order: 0
	};
}
